import React from "react";
import { Modal, Box, Typography, Grid, Card, CardContent, Button } from "@mui/material";
import { LineChartMUI, StackedBarChartMUI, TreemapChartRecharts } from "../Charts.jsx/ChartsMUI";
import { useTranslation } from "react-i18next";
const ModalChartHome = ({ open, onClose, data, selectedPeriod }) => {
	const { t } = useTranslation();
	return (
		<Modal
			open={open}
			onClose={onClose}
			sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
		>
			<Box
				sx={{
					width: "80%",
					maxHeight: "90vh",
					bgcolor: "background.paper",
					borderRadius: "8px",
					p: 4,
					overflowY: "auto",
				}}
			>
				<Typography variant="h6" align="center" mb={2}>
					{t("modal_chart_home.title")}
				</Typography>
				<Grid container spacing={2}>
					<Grid item xs={6} display="flex">
						<Card sx={{ flex: 1, height: "300px" }}>
							<CardContent sx={{ height: "100%" }}>
								<StackedBarChartMUI data={data} selectedPeriods={selectedPeriod ? [selectedPeriod] : []} />
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={6} display="flex">
						<Card sx={{ flex: 1, height: "300px" }}>
							<CardContent sx={{ height: "100%" }}>
								<TreemapChartRecharts
									data={data}
									selectedPeriods={selectedPeriod ? [selectedPeriod] : []}
								/>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12}>
						<Card>
							<CardContent>
								<LineChartMUI data={data} selectedPeriods={selectedPeriod ? [selectedPeriod] : []} />
							</CardContent>
						</Card>
					</Grid>
				</Grid>
				<Box mt={2} display="flex" justifyContent="center">
					<Button variant="contained" onClick={onClose}>
						{t("modal_chart_home.button.close")}
					</Button>
				</Box>
			</Box>
		</Modal>
	);
};

export { ModalChartHome };
